import jQuery from 'jquery';

const RcsAvailabilityMap = {
  showMap: function (targetId, coords, offset) {
    // Hide all popups
    RcsAvailabilityMap.hideAllPopups();

    // Set the position based on the provided coordinates or use a default position
    const $mapContainer = jQuery('.map-container');
    let x, y;
    if ($mapContainer.length)
      if (coords) {
        x = parseInt(coords[0]) + offset.x;
        y = parseInt(coords[1]) + offset.y;
      } else {
        // Default modal top and left coordinates
        x = 242;
        y = 250;
      }

    // Show the popup corresponding to the targetId
    jQuery('#' + targetId)
      .css({ top: y, left: x })
      .show();
  },

  hideAllPopups: function () {
    // Hide all popups
    jQuery('.map-popup').hide();
  },

  onReady: function () {
    (function ($) {
      // Display the first map by default
      // Get the image element
      const mapImage = $('.custom-home-page #rcs-map__image');
      if (mapImage.length === 0) {
        // No image found, exit
        // eslint-disable-next-line no-console
        return;
      }
      // Check if the image is already loaded
      if (mapImage[0].complete) {
        // If the image is already loaded, call the function immediately
        RcsAvailabilityMap.showMap('usa-partners');
      } else {
        // If the image is not yet loaded, set the onload event handler
        mapImage.onload = () => {
          RcsAvailabilityMap.showMap('usa-partners');
        };
      }

      $('map[name="image-map"] area').on('click', (event) => {
        // Hide all popups
        RcsAvailabilityMap.hideAllPopups();

        // Extract the href attribute value and coordinates
        const targetId = $(event.currentTarget).attr('href').substring(1);
        const coords = $(event.currentTarget).attr('coords').split(',');
        // Show the corresponding popup with a 10px offset
        RcsAvailabilityMap.showMap(targetId, coords, { x: 10, y: 10 });
        event.preventDefault();
      });

      // Attach click event listener to the document to hide popups when clicking outside
      $(document).on('click', (event) => {
        const target = $(event.target);
        if (!target.closest('.map-container').length) {
          RcsAvailabilityMap.hideAllPopups();
        }
      });

      // Attach click event listener to hide popup when clicking on the image
      $('.map-container img').on('click', () => {
        RcsAvailabilityMap.hideAllPopups();
      });
    })(jQuery);
  },
};

export default RcsAvailabilityMap;
